import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/effect-fade/effect-fade.scss';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';
import './css/index.scss';
import 'react-toastify/dist/ReactToastify.css';
import Pages from './pages';
import { Provider } from "react-redux";
import store from "./_redux/store";
import ThemeProvider from './providers/themeProvider';
import { BrowserRouter } from "react-router-dom";
import i18n from "i18next";
function App() {


    return (
        //new
        <BrowserRouter basename={"/" + getLanguage()}>
            <Provider store={store}>
                <ThemeProvider>

                    <Pages />

                </ThemeProvider>
            </Provider>

        </BrowserRouter>

    );

    
    function getLanguage() {

        var lang = i18n.language || (typeof window !== 'undefined' && window.localStorage.i18nextLng) || 'en';

        return lang;
    };
}


export default App;
